/* eslint-disable react/no-multi-comp */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _Link = _interopRequireDefault(require("Pure/Link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const item_styles = theme => ({
  root: {
    color: '#303030',
    padding: '6px 16px',
    height: 'auto',
    backgroundColor: 'transparent'
  },
  'selected': {
    '&$selected': {
      color: theme.palette.primary.main,
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      fontWeight: '500'
    }
  }
});
const sub_item_styles = theme => ({
  root: {
    color: '#303030',
    padding: '6px 16px',
    height: 'auto',
    backgroundColor: 'transparent'
  },
  'selected': {
    '&$selected': {
      color: theme.palette.primary.main,
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      fontWeight: '500'
    }
  }
});
class CustomMenuItem extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, this.props);
  }
}
const StyledMenuItem = (0, _styles.withStyles)(item_styles)(CustomMenuItem);
const StyledSubMenuItem = (0, _styles.withStyles)(sub_item_styles)(CustomMenuItem);
const text_styles = {
  root: {
    color: 'inherit',
    padding: '0 16px !important'
  }
};
class CustomListItemText extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_ListItemText.default, this.props);
  }
}
const StyledListItemText = (0, _styles.withStyles)(text_styles)(CustomListItemText);
const icon_styles = {
  root: {
    color: 'inherit'
  }
};
class CustomListItemIcon extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, this.props);
  }
}
const StyledListItemIcon = (0, _styles.withStyles)(icon_styles)(CustomListItemIcon);
const ItemLink = /*#__PURE__*/_react.default.forwardRef(function ItemLinkWithRef(props, ref) {
  return /*#__PURE__*/_react.default.createElement(_Link.default, _extends({}, props, {
    ref: ref
  }));
});
class SidebarMenuItem extends _react.Component {
  render() {
    const component = this,
      props = this.props;
    let output;
    const ItemComponent = props.level > 0 ? StyledSubMenuItem : StyledMenuItem;
    let padding_styles = {};
    if (props.level > 0) {
      padding_styles.paddingLeft = 20 + props.level * 20;
    }
    if (Object.keys(props.sub_items || {}).length === 0) {
      const Icon = props.icon;
      output = /*#__PURE__*/_react.default.createElement(ItemComponent, {
        selected: props.selected || false,
        style: padding_styles,
        href: props.url,
        component: ItemLink
      }, props.icon ? /*#__PURE__*/_react.default.createElement(StyledListItemIcon, null, /*#__PURE__*/_react.default.createElement(Icon, {
        className: "menu-icon"
      })) : undefined, /*#__PURE__*/_react.default.createElement(StyledListItemText, {
        inset: true,
        primary: props.label
      }));
      return output;
    }
    const sub_items = Object.keys(props.sub_items).map(function (name) {
      const sub_item = props.sub_items[name];
      let output = /*#__PURE__*/_react.default.createElement(SidebarMenuItem, _extends({}, sub_item, {
        key: sub_item.url,
        onClick: (e, link) => props.onClick(e, {
          ...sub_item
        })
      }));
      return output;
    });
    const Icon = props.icon;
    output = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ItemComponent, {
      button: true,
      onClick: e => props.onClick(e, {
        ...props
      }),
      selected: props.selected || false,
      style: padding_styles
    }, props.icon ? /*#__PURE__*/_react.default.createElement(StyledListItemIcon, null, /*#__PURE__*/_react.default.createElement(Icon, {
      className: "menu-icon"
    })) : undefined, /*#__PURE__*/_react.default.createElement(StyledListItemText, {
      inset: true,
      primary: props.label
    }), props.open ? /*#__PURE__*/_react.default.createElement(_ExpandLess.default, null) : /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
      in: props.open || false,
      timeout: "auto",
      unmountOnExit: true
    }, /*#__PURE__*/_react.default.createElement(_MenuList.default, {
      disablePadding: true
    }, sub_items)));
    return output;
  }
}
exports.default = SidebarMenuItem;
